import { makeStyles } from '@material-ui/core';
import React, { useCallback } from 'react';
import PlannerCard from './PlannerCard';
import { useDrop } from 'react-dnd'
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import { ITripPlannerValues } from '../types/locationTypes';
import { createNewPlanner } from './plannerHelpers';
import update from 'immutability-helper'
import { ItemTypes } from '../../../common/dndHelper'
import Popup from './Popup';
import api from "../../../store/api";
interface ListPlannersProps {
    planners: ITripPlannerValues[],
    setPlanners: any,
    locationid:any,
    getEditItemData:any
}
interface splitval {
    id:string,
    role:string
 }
const useStyles = makeStyles((theme) => ({
    addPlannerLabel: {
        fontSize: 18,
        marginLeft: 10        
    },
    card: {
        display: 'flex',
        width: '100%',
        flexDirection: 'row',
        borderRadius: 4,
        borderTop: '1px solid #DDDDDD'
    },
    dragColumn: {
        display: 'flex',
        flexDirection: 'column',
        background: '#02489D',
        width: 56,
        alignItems: 'center',
        borderTopLeftRadius: 'inherit',
        borderBottomLeftRadius: 'inherit',
        '&.sharedBy': {
            background: '#333333',
    },
    },
    dataColumn: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%'
    },
    closeIcon: {
        color: 'white',
        marginTop: 10,
        cursor: 'pointer'
    },
    haburgerIcon: {
        color: 'rgba(255,255,255, 0.50)',
        display: 'flex',
        justifySelf: 'center',
        height: 'calc(100% - 80px)',
        cursor: 'move'
    },
    inputRow: {
        display: 'flex',
        flex: '0 100%',
        flexDirection: 'row',
        borderBottom: '1px solid #DDDDDD',
        //minHeight: "40px",
    },
    inputRowWithoutBorder: {
        display: 'flex',
        flex: '0 100%',
        flexDirection: 'row',
        //minHeight: "40px",
    },
    inputRowWithTopBorder: {
        display: 'flex',
        flex: '0 100%',
        flexDirection: 'row',
        borderBottom: '1px solid #DDDDDD',
        borderTop: '1px solid #DDDDDD',
        //minHeight: "40px",
    },
    topBorder: {
        display: 'flex',
        flex: '0 100%',
        flexDirection: 'row',
        borderTop: '1px solid #DDDDDD',
    },
    labelText: {
        flex: '1 1 50%',
        fontSize: 19,
        fontWeight: 400,
        alignSelf: 'center',
        paddingLeft: 14,
        '& .linkBtn': {
            cursor: "pointer",
            color: "#3E72B3",
        },
    },
    selectField: {
        borderRadius: 0,
        flex: '1 1 50%',
    },
    textFieldInput: {
        borderRadius: 0
    },
    labelIcon: {
        fontSize: 17,
        marginBottom: -2,
        paddingLeft: 5,
        color: '#02489D',
    },
    addContainer: {
        color: '#02489D',
        display: 'flex',
        //alignItems: 'center',
        height: 24,
        marginTop: 25,
        marginRight: 25,
        cursor: 'pointer'
    },
    addIcon: {
        width: 24,
        height: 24
    },
    //addPlannerLabel: {
    //    fontSize: 18,
    //    marginLeft: 5,
    //},
    shiftHourBase: {
        marginLeft: 14
    },
    shiftHour: {
        width: "100%",
        //minWidth: "100%",
        '& .shiftHourGrid': {
            minWidth: "100%",
            alignItems: "center",
            '&.header': {
                minHeight: "40px",
                borderBottom: '1px solid #DDDDDD',
            },
            '&.body': {
                minHeight: "30px",
                padding: "3px 0px",
            },
            '& .labelText': {
                fontSize: 19,
                fontWeight: 400,
                paddingLeft: 14,
            },
            '& .labelSubText': {
                fontSize: 19,
                fontWeight: 400,
            },
            '& .title': {
                fontSize: 15,
                //fontWeight: 300,
                paddingLeft: 14,
            },
            '& .subTitle': {
                fontSize: 15,
            },
            '& .weekDayGrid': {
                minWidth: "100%",
                justifyContent: "space-around",
                alignItems: "center",
                gridColumnGap: "1%",
                '& .MuiGrid-item': {
                    flexGrow: 0,
                    maxWidth: "13%",
                    flexBasis: "13%",
                    '& .dayTitle': {
                        width: "100%",
                        fontSize: 17,
                        fontWeight: 700,
                        color: "#363636",
                        textAlign: "center",
                        paddingLeft: 2
                    },
                },
            },
        },
    },
}));

const ListPlanners : React.FC<ListPlannersProps> = ({
    planners,
    setPlanners,
    locationid,
    getEditItemData,
}) => {
   
    const classes = useStyles();
    const [{ canDrop, isOver }, drop] = useDrop(() => ({
        accept: ItemTypes.PLANNER_LOCATION,
        collect: (monitor) => ({
            isOver: monitor.isOver(),
            canDrop: monitor.canDrop()
        })
    }));

    const moveCard = useCallback(
        (dragIndex: number, hoverIndex: number) => {
            const dragCard = planners[dragIndex]
            setUpdatedPlanners(
                update(planners, {
                    $splice: [
                        [dragIndex, 1],
                        [hoverIndex, 0, dragCard],
                    ],
                }),
            )
        },
        [planners],
    )

    const setUpdatedPlanners = (newPanners: ITripPlannerValues[]) => {
        for (let index = 0; index < newPanners.length; index++) {
            const element = newPanners[index];
            element.sequence = index + 1;
        }
        setPlanners(newPanners);
    }

    const addPlanner = () => {
        setUpdatedPlanners([...planners, createNewPlanner()]);
    }
    const [popStates, setpopStates] = React.useState(false);
    const addanotherPlanner = async () => {
     setpopStates(true)
    }
    const handleplannerlocation =(value:any)=>{   
        if(value !=null)
        {
            let val:any=[];
            var res =value.split(",");     
            var splitval = res.map((x:any) => x.split("/"));
            splitval.map((x:any,index:any) => val.push(x));
            return val;
        }    
     }


    return (
        <>
            <div
                ref={drop}
                role={'Dustbin'}
                style={{ backgroundColor: isOver ? 'lightgray' : 'white', width: '100%' }}
            >
                {planners.map((card, i) => <PlannerCard
                            key={card.tripPlannerId}
                            parentClasses={classes}
                            moveCard={moveCard}
                            index={i}
                            planner={card}
                    sharedlocation ={handleplannerlocation(card.sharedlocation)}
                            setUpdatedPlanners={setUpdatedPlanners}
                    planners={planners}
                    setPlanners={setPlanners}
                />)}
            </div>
            <div className={classes.addContainer} onClick={addPlanner} tabIndex={998}>
                <span><AddCircleOutlineIcon className={classes.addIcon} /></span>
                <span className={classes.addPlannerLabel}>Add New Planner</span>
            </div>
            <div className={classes.addContainer} onClick={addanotherPlanner} tabIndex={999}>
                <span><AddCircleOutlineIcon className={classes.addIcon} /></span>
                <span className={classes.addPlannerLabel}>Add  Planner From Another Location</span>
            </div>
            <Popup
                popState={popStates}
                setPopState={setpopStates}
                locationid={locationid}
                getEditItemData={getEditItemData}
            />
        </>
    );
}

export default ListPlanners;



